import { Box, useTheme } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { getMaterialColor } from '../../helpers';
import { PreviewMap } from '../PreviewMap';

const mapContainerStyles = {
  flex: 1,
  minHeight: 200,
  mt: 2,
  overflow: 'hidden',
  borderRadius: 1.5,
};

const getMarkerColor = (material: unknown, primaryColor: string) => {
  if (typeof material !== 'string' || !material.trim()) {
    return primaryColor;
  }

  const [red, green, blue] = getMaterialColor(
    material.trim().toLowerCase()
  );

  return `rgb(${red}, ${green}, ${blue})`;
};

const PreviewMapContainer = ({ control }) => {
  const theme = useTheme();
  const latitude = useWatch({
    control,
    name: 'latitude',
  });
  const longitude = useWatch({
    control,
    name: 'longitude',
  });
  const material = useWatch({
    control,
    name: 'material',
  });
  const markerColor = getMarkerColor(material, theme.palette.primary.main);

  if (
    [longitude, latitude].includes('') ||
    typeof longitude === 'undefined' ||
    typeof latitude === 'undefined'
  ) {
    return null;
  }

  return (
    <Box sx={mapContainerStyles}>
      <PreviewMap
        longitude={parseFloat(longitude)}
        latitude={parseFloat(latitude)}
        markerColor={markerColor}
      />
    </Box>
  );
};

export { PreviewMapContainer };
